import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Landing = () => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 20);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    const fadeT = setTimeout(() => {
      setLeaving(true);
    }, 1600);

    const navT = setTimeout(() => {
      navigate('/home');
    }, 2000);

    return () => {
      clearTimeout(fadeT);
      clearTimeout(navT);
    };
  }, [navigate]);

  const handleEnter = () => {
    setLeaving(true);
    setTimeout(() => {
      navigate('/home');
    }, 350);
  };

  return (
    <div
      className={`min-h-screen bg-white flex flex-col transition-opacity duration-300 ${
        leaving ? 'opacity-0' : visible ? 'opacity-100' : 'opacity-0'
      }`}
    >
      {/* Logo in top left */}
      <div className="absolute top-6 left-6">
        <img
          src="/logos/logo.png"
          alt="Ditris"
          className="h-8 w-auto"
        />
      </div>

      {/* Center logo - clickable to enter */}
      <div className="flex-1 flex items-center justify-center">
        <button
          onClick={handleEnter}
          className="focus:outline-none group transition-opacity hover:opacity-70"
        >
          <img
            src="/logos/logo.png"
            alt="Ditris"
            className="w-64 md:w-96 h-auto transition-transform group-hover:scale-105 duration-300"
          />
        </button>
      </div>
    </div>
  );
};

export default Landing;
